import { render, staticRenderFns } from "./NotaVotada.vue?vue&type=template&id=2a08af1e&"
import script from "./NotaVotada.vue?vue&type=script&lang=js&"
export * from "./NotaVotada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports